var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v("Step 5 of 9: Interventions"),
        ]),
        _c("div", { staticClass: "grid grid-cols-1 gap-3" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Frequency "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      name: "dietary_goals_frequency",
                      placeholder: "Select Frequency",
                      getParentCustom: "clientWidth",
                      options: _vm.frequencyOptions,
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("dietary_goals_frequency", val),
                    },
                    model: {
                      value: _vm.formData.dietary_goals_frequency,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "dietary_goals_frequency", $$v)
                      },
                      expression: "formData.dietary_goals_frequency",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Special Requirements "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "dietary_goals_special_requirement",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField(
                          "dietary_goals_special_requirement",
                          val
                        ),
                    },
                    model: {
                      value:
                        _vm.localFormData.dietary_goals_special_requirement,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "dietary_goals_special_requirement",
                          $$v
                        )
                      },
                      expression:
                        "localFormData.dietary_goals_special_requirement",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(1),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Daily Tasks "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "housekeeping_daily_task",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("housekeeping_daily_task", val),
                    },
                    model: {
                      value: _vm.localFormData.housekeeping_daily_task,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "housekeeping_daily_task",
                          $$v
                        )
                      },
                      expression: "localFormData.housekeeping_daily_task",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Assistance Level "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      name: "housekeeping_assistance_level",
                      getParentCustom: "clientWidth",
                      options: _vm.assistance_level,
                      placeholder: "Select",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("housekeeping_assistance_level", val),
                    },
                    model: {
                      value: _vm.localFormData.housekeeping_assistance_level,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "housekeeping_assistance_level",
                          $$v
                        )
                      },
                      expression: "localFormData.housekeeping_assistance_level",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(2),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Support Type "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "ambulance_support_type",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("ambulance_support_type", val),
                    },
                    model: {
                      value: _vm.localFormData.ambulance_support_type,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "ambulance_support_type",
                          $$v
                        )
                      },
                      expression: "localFormData.ambulance_support_type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Pain Monitoring "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "ambulance_pain_monitoring",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("ambulance_pain_monitoring", val),
                    },
                    model: {
                      value: _vm.localFormData.ambulance_pain_monitoring,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "ambulance_pain_monitoring",
                          $$v
                        )
                      },
                      expression: "localFormData.ambulance_pain_monitoring",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(3),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Frequency "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      name: "bathing_frequency",
                      getParentCustom: "clientWidth",
                      placeholder: "Enter",
                      inputClass: "w-full",
                      options: _vm.bathing_frequency,
                    },
                    on: {
                      input: (val) => _vm.updateField("bathing_frequency", val),
                    },
                    model: {
                      value: _vm.localFormData.bathing_frequency,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "bathing_frequency", $$v)
                      },
                      expression: "localFormData.bathing_frequency",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Supervision Level "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      options: _vm.bathing_supervision_level,
                      getParentCustom: "clientWidth",
                      name: "bathing_supervision_level",
                      placeholder: "Select",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("bathing_supervision_level", val),
                    },
                    model: {
                      value: _vm.localFormData.bathing_supervision_level,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "bathing_supervision_level",
                          $$v
                        )
                      },
                      expression: "localFormData.bathing_supervision_level",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._m(4),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Frequency "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      options: _vm.toileting_frequency,
                      name: "toileting_frequency",
                      getParentCustom: "clientWidth",
                      placeholder: "Select",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("toileting_frequency", val),
                    },
                    model: {
                      value: _vm.localFormData.toileting_frequency,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "toileting_frequency", $$v)
                      },
                      expression: "localFormData.toileting_frequency",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Hygiene Protocol "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "toileting_hygiene",
                      placeholder: "Enter",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("toileting_hygiene", val),
                    },
                    model: {
                      value: _vm.localFormData.toileting_hygiene,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "toileting_hygiene", $$v)
                      },
                      expression: "localFormData.toileting_hygiene",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("General Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "toileting_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("toileting_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.toileting_notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "toileting_notes", $$v)
                      },
                      expression: "localFormData.toileting_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Dietary/Nutrition Goals"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Light Housekeeping"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [
        _vm._v("Ambulance Assistance"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [_vm._v("Bathing")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-span-2" }, [
      _c("h5", { staticClass: "text-base font-medium" }, [_vm._v("Toileting")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }